<template>
  <div>
    <div class="i-layout-page-header">
      <span class="ivu-page-header-title">{{ $route.meta.title }}</span>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Row style="margin: 20px 0">
        <Col span="24">
          <h3>数据看板</h3>
        </Col>
      </Row>
      <Row type="flex" justify="space-around" align="middle" style="margin: 20px 0;text-align: center">
        <Col span="4">
          <div style="font-weight: bold;font-size: 20px">总数</div>
          <div>{{ data.pig_base.pig_num }}头</div>
        </Col>
        <Col span="4">
          <div style="font-weight: bold;font-size: 20px">出栏</div>
          <div>{{ data.pig_base.out_num }}头</div>
        </Col>
        <Col span="4">
          <div style="font-weight: bold;font-size: 20px">销售</div>
          <div>{{ data.pig_base.sale_num }}头</div>
        </Col>
        <Col span="4">
          <div style="font-weight: bold;font-size: 20px">死亡</div>
          <div>{{ data.pig_base.dead_num }}头</div>
        </Col>
      </Row>

      <Row style="margin: 20px 0">
        <Col>
          <h3>快捷入口</h3>
        </Col>
      </Row>
      <Row type="flex" justify="space-around" align="middle" style="margin: 20px 0;text-align: center">
        <Col span="4">
          <Button type="primary" @click="$router.push('/admin/digitalLivestock/pigFarm/breeding/pigBreedCopulation/list')">配种</Button>
        </Col>
        <Col span="4">
          <Button type="primary" @click="$router.push('/admin/digitalLivestock/pigFarm/pigChild/pigChildInfo/list')">仔猪</Button>
        </Col>
        <Col span="4">
          <Button type="primary" @click="$router.push('/admin/digitalLivestock/pigFarm/outManage/pigOut/list')">出栏</Button>
        </Col>
        <Col span="4">
          <Button type="primary" @click="$router.push('/admin/digitalLivestock/pigFarm/fodderManage/pigFodder/list')">饲料</Button>
        </Col>
      </Row>
      <Row type="flex" justify="space-around" align="middle" style="margin: 20px 0;text-align: center">
        <Col span="4">
          <Button type="primary" @click="$router.push('/admin/digitalLivestock/pigFarm/slaughterManage/pigSlaughterLog/list')">屠宰</Button>
        </Col>
        <Col span="4">
          <Button type="primary" @click="$router.push('/admin/digitalLivestock/pigFarm/prevention/pigQuarantine/list')">防疫</Button>
        </Col>
        <Col span="4">
          <Button type="primary" @click="$router.push('/admin/digitalLivestock/pigFarm/device/pigDeviceEnvironment/list')">环境</Button>
        </Col>
        <Col span="4">
          <Button type="primary" @click="$router.push('/admin/digitalLivestock/pigFarm/harmless/pigHarmlessDeath/list')">死亡</Button>
        </Col>
      </Row>

      <Row style="margin: 20px 0">
        <Col>
          <h3>数据统计</h3>
        </Col>
      </Row>
      <Row type="flex" justify="space-around" align="middle" style="margin: 20px 0;text-align: center">
        <Col span="24">
          <div ref="typesChart" style="width: 100%;height: 400px"></div>
        </Col>
      </Row>
      <Row type="flex" justify="space-around" align="middle" style="margin: 20px 0;text-align: center">
        <Col span="12">
          <div ref="salesChart" style="width: 100%;height: 400px"></div>
        </Col>
        <Col span="12">
          <div ref="yieldChart" style="width: 100%;height: 400px"></div>
        </Col>
      </Row>
      <Row type="flex" justify="space-around" align="middle" style="margin: 20px 0;text-align: center">
        <Col span="12">
          <div ref="breedChart" style="width: 100%;height: 400px"></div>
        </Col>
        <Col span="12">
          <div ref="feedChart" style="width: 100%;height: 400px"></div>
        </Col>
      </Row>

    </Card>

  </div>
</template>

<script>
import {dataVisualizationApi} from '@/api/pigFarm/pigDataVisualization'
import * as echarts from 'echarts';

export default {
  name: 'pigDataVisualization',
  inject: ['reload'],
  data() {
    return {
      salesChartInstance: null,
      yieldChartInstance: null,
      typesChartInstance: null,
      feedChartInstance: null,
      breedChartInstance: null,
      data: {
        pig_base: {
          pig_num: 0,
          out_num: 0,
          sale_num: 0,
          dead_num: 0,
        },
        data_statistics: {
          sale_data: {
            month: [],
            amount: [],
          },
          weight_data: {
            month: [],
            weight: [],
          },
          type_data: [],
          feed_data: {
            month: [],
            weight: [],
          },
          breed_data: {
            month: [],
            num: [],
          },
        }
      },
    }
  },

  created() {

  },

  mounted() {
    this.loadData()
  },

  beforeDestroy() {
    if (this.salesChartInstance) this.salesChartInstance.dispose();
    if (this.yieldChartInstance) this.yieldChartInstance.dispose();
    if (this.typesChartInstance) this.typesChartInstance.dispose();
    if (this.feedChartInstance) this.feedChartInstance.dispose();
    if (this.breedChartInstance) this.breedChartInstance.dispose();
  },

  methods: {
    loadData() {
      dataVisualizationApi().then(res => {
        if (res.code === 200) {
          this.data = res.data
          this.initSalesChart()
          this.initYieldChart()
          this.initTypesChart()
          this.initFeedChart()
          this.initBreedChart()
        }else{
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    // 产值折线图
    initSalesChart() {

      // 初始化echarts实例
      this.salesChartInstance = echarts.init(this.$refs.salesChart);

      // 指定图表的配置项和数据
      const salesOption = {
        // 标题
        title: {
          text: '产值月趋势 (近6个月)',
          x: 'center',
          padding: 10,
          textStyle: {
            'color': '#516b91'
          }
        },
        // 图例
        legend: {
          padding: 10,
          right: 10,
          textStyle: {
            'color': '#516b91'
          }
        },
        // x轴文字
        xAxis: {
          type: 'category',
          data: this.data.data_statistics.sale_data.month,
        },
        // y轴的文字
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: function (value) {
              return value + '元';
            }
          }
        },
        // 折线
        series: [{
          // 数据
          data: this.data.data_statistics.sale_data.amount,
          // 类型
          type: 'line',
          // 内容
          name: '销售金额',
          // 样式
          itemStyle: {
            normal: {
              // 点颜色
              color: '#478bee',
              // 线颜色
              lineStyle: {
                color: '#47c16a'
              }
            }
          },
          // 显示数据
          label: {
            show: true,
            position: 'top',
            color: '#000',
            fontSize: 12,
            formatter: function (params) {
              return params.value + '元';
            }
          },


        }],
      };

      // 使用刚指定的配置项和数据显示图表。
      this.salesChartInstance.setOption(salesOption);

    },

    // 产量折线图
    initYieldChart(){

      // 初始化echarts实例
      this.yieldChartInstance = echarts.init(this.$refs.yieldChart);

      // 指定图表的配置项和数据
      const yieldOption = {
        // 标题
        title: {
          text: '产量月趋势 (近6个月)',
          x: 'center',
          padding: 10,
          textStyle: {
            'color': '#516b91'
          }
        },
        // 图例
        legend: {
          padding: 10,
          right: 10,
          textStyle: {
            'color': '#516b91'
          }
        },
        // x轴文字
        xAxis: {
          type: 'category',
          data: this.data.data_statistics.weight_data.month,
        },
        // y轴的文字
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: function (value) {
              return value + 'kg';
            }
          }
        },
        // 折线
        series: [{
          // 数据
          data: this.data.data_statistics.weight_data.weight,
          // 类型
          type: 'line',
          // 内容
          name: '销售重量',
          // 样式
          itemStyle: {
            normal: {
              // 点颜色
              color: '#478bee',
              // 线颜色
              lineStyle: {
                color: '#47c16a'
              }
            }
          },
          // 显示数据
          label: {
            show: true,
            position: 'top',
            color: '#000',
            fontSize: 12,
            formatter: function (params) {
              return params.value + 'kg';
            }
          },


        }],
      };

      // 使用刚指定的配置项和数据显示图表。
      this.yieldChartInstance.setOption(yieldOption);

    },

    // 繁育折线图
    initBreedChart() {

      // 初始化echarts实例
      this.breedChartInstance = echarts.init(this.$refs.breedChart);

      // 指定图表的配置项和数据
      const breedOption = {
        // 标题
        title: {
          text: '繁育月趋势 (近6个月)',
          x: 'center',
          padding: 10,
          textStyle: {
            'color': '#516b91'
          }
        },
        // 图例
        legend: {
          padding: 10,
          right: 10,
          textStyle: {
            'color': '#516b91'
          }
        },
        // x轴文字
        xAxis: {
          type: 'category',
          data: this.data.data_statistics.breed_data.month,
        },
        // y轴的文字
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: function (value) {
              return value + '头';
            }
          }
        },
        // 折线
        series: [{
          // 数据
          data: this.data.data_statistics.breed_data.num,
          // 类型
          type: 'line',
          // 内容
          name: '繁育头数',
          // 样式
          itemStyle: {
            normal: {
              // 点颜色
              color: '#478bee',
              // 线颜色
              lineStyle: {
                color: '#47c16a'
              }
            }
          },
          // 显示数据
          label: {
            show: true,
            position: 'top',
            color: '#000',
            fontSize: 12,
            formatter: function (params) {
              return params.value + '头';
            }
          },


        }],
      };

      // 使用刚指定的配置项和数据显示图表。
      this.breedChartInstance.setOption(breedOption);

    },

    // 类别扇形图
    initTypesChart() {
      // 类别扇形图

      // 初始化扇形图实例
      this.typesChartInstance = echarts.init(this.$refs.typesChart);

      // 检查类型数据是否存在且不为空
      if (this.data.data_statistics.type_data && this.data.data_statistics.type_data.length > 0) {
        // 准备扇形图数据
        const typesData = this.data.data_statistics.type_data.map(item => ({
          name: item.name || '未知类型',
          value: item.count || 0,
        }));

        // 指定图表的配置项和数据
        const typesOption = {
          // 标题
          title: {
            text: '猪只类别分布',
            x: 'center',
            padding: 10,
            textStyle: {
              'color': '#516b91'
            }
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            left: 'left',
            textStyle: {
              color: '#516b91'
            }
          },
          series: [
            {
              name: '类型分布',
              type: 'pie',
              radius: '60%',
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 2
              },
              label: {
                show: false,
                position: 'center',
                formatter: function (params) {
                  return params.name + ': ' + params.value + '头';
                }
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: 20,
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: false
              },
              data: typesData
            }
          ]
        };

        // 使用刚指定的配置项和数据显示图表。
        this.typesChartInstance.setOption(typesOption);
      }


    },

    // 饲料柱状图
    initFeedChart() {
      // 初始化柱状图
      this.feedChartInstance = echarts.init(this.$refs.feedChart);

      // 配置新柱状图数据和样式
      const feedOption = {
        title: {
          text: '饲料投放月统计 (近6个月)',
          x: 'center',
          padding: 10,
          textStyle: {
            'color': '#516b91'
          }
        },
        tooltip: {},
        xAxis: {
          data: this.data.data_statistics.feed_data.month,
        },
        yAxis: {},
        series: [{
          name: '投放重量',
          type: 'bar',
          data: this.data.data_statistics.feed_data.weight,
        }],
        // 显示数据
        label: {
          show: true,
          position: 'top',
          color: '#000',
          fontSize: 12,
          formatter: function (params) {
            return params.value + 'kg';
          }
        },
      };

      // 使用配置项和数据显示图表
      this.feedChartInstance.setOption(feedOption);
    },

  }
}
</script>
